angular.module('sharecrf.progress-status').factory('ProgressStatus', [
    'RecordService',
    'CrdConfigurationService',
    'Event',
    function(RecordService, CrdConfigurationService, Event) {
        var data = {};
        reset();

        /**
         * Calcula porcentajes ajustados para la barra visual que compensan el padding
         * y aseguran un ancho mínimo para que cada segmento no-nulo sea visible
         * @param {Object} data - Objeto con los porcentajes reales y el total
         * @returns {Array<number>} - Array con los porcentajes ajustados para la barra
         */
        function calculateAdjustedPercentages(data) {
            var percentages = [
                data.completedPercent,
                data.overduePercent,
                data.pendingPercent,
                data.plannedPercent,
            ];

            // Exageramos valores no-nulos pero menores
            // de 2% (aproximadamente 4.5px) para que
            // se vean
            percentages.forEach(function(value, index) {
                if (value != 0 && value < 2) {
                    percentages[index] = 2;
                }
            });

            // Aseguramos que la suma de los porcentajes ajustados sea 100
            var total = percentages.reduce(function(sum, value) {
                return sum + value;
            }, 0);

            percentages.forEach(function(value, index) {
                percentages[index] = (value / total) * 100;
            });

            return percentages;
        }

        function reload() {
            var recordStats = RecordService.get().stats || {};

            // Mantener compatibilidad con el sistema anterior
            data.completedPercent = Math.round(recordStats.rfnfp || 0);

            if (CrdConfigurationService.hasMissingData()) {
                data.missing = recordStats.rmfn;
                data.requiredMissing = recordStats.rmfn || 0;
                data.optionalMissing = recordStats.omfn || 0;
                data.hiddenMissing = recordStats.hmfn || 0;
            }

            data.hasScheduledVisits = CrdConfigurationService.hasScheduledVisits();
            data.total = recordStats.rfn || 0;
            data.completed = recordStats.rfnf || 0;
            if (data.hasScheduledVisits) {
                data.overdue = recordStats.rfnp1 || 0;
                data.pending = recordStats.rfnp2 || 0;
                data.planned = recordStats.rfnp3 || 0;
                data.overduePercent = Math.round(recordStats.rfnp1p || 0);
                data.pendingPercent = Math.round(recordStats.rfnp2p || 0);
                data.plannedPercent = Math.round(recordStats.rfnp3p || 0);

                if (data.total > 0) {
                    // Calcular porcentajes ajustados para la barra visual
                    var adjustedPercentages = calculateAdjustedPercentages(data);

                    data.completedPercentAdjusted = adjustedPercentages[0];
                    data.overduePercentAdjusted = adjustedPercentages[1];
                    data.pendingPercentAdjusted = adjustedPercentages[2];
                    data.plannedPercentAdjusted = adjustedPercentages[3];
                }
            }
            else {
                data.pending = recordStats.rfn - recordStats.rfnf;
                data.pendingPercent = 100 - data.completedPercent;
            }

            // Disparar evento para notificar actualización
            Event.trigger('progressStatusReload');
        }

        function reset() {
            data = {
                completedPercent: 0,
                missing: 0,
                requiredMissing: 0,
                optionalMissing: 0,
                hiddenMissing: 0,
                hasScheduledVisits: false,
                completed: 0,
                overdue: 0,
                pending: 0,
                planned: 0,
                total: 0,
                overduePercent: 0,
                pendingPercent: 0,
                plannedPercent: 0,
                completedPercentAdjusted: 0,
                overduePercentAdjusted: 0,
                pendingPercentAdjusted: 0,
            };
        }

        return {
            get: function() {
                return data;
            },
            init: function() {
                reload();
            },
            reload: function() {
                reload();
            },
            clear: function() {
                reset();
            },
        };
    },
]);
